import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Layout from './layouts/layout';
import Lifetime from './pages/offer/Lifetime';
import LifetimeEngage from './pages/offer/LifetimeEngage';
const Home = lazy(() => import('./pages/home'));
const FAQ = lazy(() => import('./pages/faq'));
const PublishAndEngage = lazy(() => import('./components/pricingPanel/index'));
const Pricing = lazy(() => import('./pages/pricing'));

const getRoutes = (lang = 'en') => {
  const isLifetimeOffer = process.env['REACT_APP_LIFETIME_OFFER'];

  if (isLifetimeOffer) {
    return [
      { path: '/', element: <Navigate to={`/${lang}`} /> },
      { path: '/:lang', exact: true, element: <Lifetime /> },
      // { path: '/:lang/engage', exact: true, element: <LifetimeEngage /> }  
    ]
  }

  return [
    { path: '/', element: <Navigate to={`/${lang}`} /> },
    {
      path: `/:lang`,
      element: <Layout />,
      children: [
        {
          path: '/', element: <Home />,
        }, {
          path: '/pricing', element: <Pricing />,
          children: [
            { path: '/', element: <PublishAndEngage /> },
            { path: '/publish', element: <PublishAndEngage /> },
            // { path: '/engage', element: <PublishAndEngage /> }
          ]
        }, {
          path: '/faq', element: <FAQ />
        }, {
          path: '/*', element: <h1 style={{ textAlign: 'center' }}>Page not found</h1>
        }
      ]
    },
    { path: '/:lang/offer/lifetime', exact: true, element: <Lifetime /> },
    { path: '/:lang/offer/lifetime/engage', exact: true, element: <LifetimeEngage /> },
  ];
}

export default getRoutes;
